module.exports = __webpack_public_path__ + "img-front/logo_tr.fa6a5392.png";